import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'RF'},//0
    {title: 'ID fuente interna'},//1
    {title: 'Número de origen'},//2
    {title: 'Fecha de vencimiento'},//3
    {title: 'Fecha de contabilización'},//4
    {title: 'Fecha aplicada'},//5
    {title: 'Referencia 1'},//6
    {title: 'Referencia 2'},//7
    {title: 'Info.detallada'},//8
    {title: 'Importe'},//9
    {title: 'Importe de descuento por pronto pago'},//10
    {title: 'Saldo pendiente'},//11
    {title: 'Importe aplicado'},//12
    {title: 'Importe (ML)'},//13
    {title: 'Saldo vencido (ML)'},//14
    {title: 'Importe aplicado (ML)'},//15
    {title: 'Importe (MEST)'},//16
    {title: 'Número de reconciliación'},//17
    {title: 'Cuenta de mayor / Código SN'},//18
    {title: 'Nº cta.mayor'},//19
    ];

class TransactionsModal extends Component {
    componentDidMount(): void {
        this.closeAction();
    }

    closeTransaction = async () => {
        $('#transactionsModal').modal('hide');
    }

    closeAction = () => {
        const { cleanData } = this.props;
        $('#transactionsModal').on('hidden.bs.modal', function () {
            cleanData();
        });
    };


    render() {
        const {data, selectAccount} = this.props;

        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="transactionsModal"></div>;
        }


        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll"  role="dialog"  id="transactionsModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Transacciones aplicadas</h4>
                                <button type="button" className="close" onClick={this.closeTransaction} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div  className="w-100 table-scroll tab-pane fade show active "  aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"transactionsModal"} action={selectAccount}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn botonCerrar text-white" onClick={this.closeTransaction}>Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TransactionsModal;